import { RootState } from "../resources/reduxTypes";
import { useDispatch } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

export type AppThunkDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

// Define new dispatch that returns a promise, so we can use .then with types
export const useAsyncDispatch = () => useDispatch<AppThunkDispatch>();
